import React from 'react';
import logo from '../../assets/images/logo.png';
import styles from './Header.module.css';

function Header() {
  // mantenemos el mismo diseño y estilos, pero sin navegación ni handlers sobre el logo
  let deviceType = 'desktop';
  if (typeof window !== 'undefined') {
    const width = window.innerWidth;
    if (width <= 760) deviceType = 'mobile';
    else if (width > 760 && width <= 1024) deviceType = 'tablet';
  }

  const padding =
    deviceType === 'mobile'
      ? '18px 8px 8px 8px'
      : deviceType === 'tablet'
      ? '28px 24px'
      : '24px 32px';

  const logoHeight =
    deviceType === 'mobile'
      ? '7vw'
      : deviceType === 'tablet'
      ? 48
      : 40;

  const buttonFontSize =
    deviceType === 'mobile'
      ? '11px'
      : deviceType === 'tablet'
      ? '13px'
      : '14px';

  const buttonPadding =
    deviceType === 'mobile'
      ? '11px 11px'
      : deviceType === 'tablet'
      ? '13px 22px'
      : '12px 19px';

  return (
    <header
      className="site-header"
      style={{
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding,
        position: 'fixed',
        top: 0,
        left: 0,
        background: 'rgba(255, 255, 255, 0)',
        zIndex: 100,
        boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
        backdropFilter: 'blur(9px)'
      }}
    >
      {/* Logo SIN navegación: mismo markup visual (clase logo-link) pero sin <a> ni handlers */}
      <div className="logo-link" aria-hidden="true" style={{ display: 'inline-block' }}>
        <img
          src={logo}
          alt="Logo Plink"
          style={{
            height: logoHeight,
            maxHeight: 48,
            transition: 'height 0.2s'
          }}
        />
      </div>

      <a
        href="https://comercios.plink.r4conecta.io/"
        target="_blank"
        rel="noopener noreferrer"
        className={styles.startButton}
        style={{
          padding: buttonPadding,
          fontSize: buttonFontSize
        }}
      >
        INICIAR SESIÓN
      </a>
    </header>
  );
}

export default Header;
